// WhatsApp Business API Service
// Echte API-Anbindung ohne Mock-Daten

class WhatsAppApiService {
  constructor() {
    this.baseUrl = '/api/whatsapp';
    this.accessToken = null;
    this.phoneNumberId = null;
  }

  // Initialisierung mit Credentials
  async initialize() {
    try {
      const response = await fetch(`${this.baseUrl}/config`);
      if (response.ok) {
        const config = await response.json();
        this.accessToken = config.accessToken;
        this.phoneNumberId = config.phoneNumberId;
        return true;
      }
      return false;
    } catch (error) {
      console.error('WhatsApp API Initialisierung fehlgeschlagen:', error);
      return false;
    }
  }

  // Nachricht senden
  async sendMessage(to, message, type = 'text') {
    try {
      const response = await fetch(`${this.baseUrl}/send`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          to,
          message,
          type
        })
      });

      if (response.ok) {
        const result = await response.json();
        return {
          success: true,
          messageId: result.messageId,
          timestamp: new Date().toISOString()
        };
      } else {
        const error = await response.json();
        throw new Error(error.message || 'Nachricht konnte nicht gesendet werden');
      }
    } catch (error) {
      console.error('Fehler beim Senden der Nachricht:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }

  // Kontakte abrufen
  async getContacts() {
    try {
      const response = await fetch(`${this.baseUrl}/contacts`);
      if (response.ok) {
        const contacts = await response.json();
        return contacts;
      }
      return [];
    } catch (error) {
      console.error('Fehler beim Abrufen der Kontakte:', error);
      return [];
    }
  }

  // Nachrichtenverlauf abrufen
  async getMessages(contactId, limit = 50) {
    try {
      const response = await fetch(`${this.baseUrl}/messages/${contactId}?limit=${limit}`);
      if (response.ok) {
        const messages = await response.json();
        return messages;
      }
      return [];
    } catch (error) {
      console.error('Fehler beim Abrufen der Nachrichten:', error);
      return [];
    }
  }

  // Webhook-Status prüfen
  async checkWebhookStatus() {
    try {
      const response = await fetch(`${this.baseUrl}/webhook/status`);
      if (response.ok) {
        const status = await response.json();
        return status;
      }
      return { connected: false };
    } catch (error) {
      console.error('Fehler beim Prüfen des Webhook-Status:', error);
      return { connected: false };
    }
  }

  // Medien hochladen
  async uploadMedia(file) {
    try {
      const formData = new FormData();
      formData.append('media', file);

      const response = await fetch(`${this.baseUrl}/media/upload`, {
        method: 'POST',
        body: formData
      });

      if (response.ok) {
        const result = await response.json();
        return {
          success: true,
          mediaId: result.mediaId,
          url: result.url
        };
      } else {
        throw new Error('Medien-Upload fehlgeschlagen');
      }
    } catch (error) {
      console.error('Fehler beim Medien-Upload:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }

  // Template-Nachrichten abrufen
  async getTemplates() {
    try {
      const response = await fetch(`${this.baseUrl}/templates`);
      if (response.ok) {
        const templates = await response.json();
        return templates;
      }
      return [];
    } catch (error) {
      console.error('Fehler beim Abrufen der Templates:', error);
      return [];
    }
  }

  // Template-Nachricht senden
  async sendTemplate(to, templateName, parameters = []) {
    try {
      const response = await fetch(`${this.baseUrl}/send/template`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          to,
          templateName,
          parameters
        })
      });

      if (response.ok) {
        const result = await response.json();
        return {
          success: true,
          messageId: result.messageId
        };
      } else {
        throw new Error('Template-Nachricht konnte nicht gesendet werden');
      }
    } catch (error) {
      console.error('Fehler beim Senden der Template-Nachricht:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }

  // Kontakt hinzufügen/aktualisieren
  async updateContact(phoneNumber, contactData) {
    try {
      const response = await fetch(`${this.baseUrl}/contacts/${phoneNumber}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(contactData)
      });

      if (response.ok) {
        const result = await response.json();
        return {
          success: true,
          contact: result
        };
      } else {
        throw new Error('Kontakt konnte nicht aktualisiert werden');
      }
    } catch (error) {
      console.error('Fehler beim Aktualisieren des Kontakts:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }

  // Nachrichtenstatus abrufen
  async getMessageStatus(messageId) {
    try {
      const response = await fetch(`${this.baseUrl}/messages/status/${messageId}`);
      if (response.ok) {
        const status = await response.json();
        return status;
      }
      return { status: 'unknown' };
    } catch (error) {
      console.error('Fehler beim Abrufen des Nachrichtenstatus:', error);
      return { status: 'error' };
    }
  }
}

// Singleton-Instanz exportieren
export const whatsappApiService = new WhatsAppApiService();
export default whatsappApiService;

